import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e5897c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-administrator-diagnostics-root-filter" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box__headline" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Filteri ")
], -1))
const _hoisted_4 = { class: "box__filters" }
const _hoisted_5 = { class: "form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            model: _ctx.formData,
            ref: "formComponent",
            onSubmit: _withModifiers(_ctx.getDiagnosticsByFilter, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Igrači",
                prop: "filter.user_id"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formData.filter.user_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.filter.user_id) = $event)),
                    placeholder: "Odaberite",
                    onChange: _ctx.getDiagnosticsByFilter
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Svi igrači",
                        value: "*"
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.players, (player, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: `${player.content.name} ${player.content.surname}`,
                          value: player.id,
                          key: index
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Kategorija",
                prop: "filter.diagnostic_category_id"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formData.filter.diagnostic_category_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.filter.diagnostic_category_id) = $event)),
                    placeholder: "Odaberite",
                    onChange: _ctx.getDiagnosticsByFilter
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Sve kategorije",
                        value: "*"
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diagnosticCategories, (diagnosticCategory, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: `${diagnosticCategory.content.name}`,
                          value: diagnosticCategory.id,
                          key: index
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Period",
                prop: "filter.date"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.formData.filter.date,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.filter.date) = $event)),
                    type: "daterange",
                    format: "DD.MM.YYYY.",
                    "start-placeholder": "Odaberite",
                    "end-placeholder": "Odaberite",
                    onChange: _ctx.getDiagnosticsByFilter
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "onSubmit"])
        ])
      ])
    ])
  ]))
}